module.exports = __webpack_public_path__ + "img/xuankuanhezuo.4d6b2cf2.png";